import { render, staticRenderFns } from "./TechnicalInformationComponent.vue?vue&type=template&id=497e8422&scoped=true"
import script from "./TechnicalInformationComponent.vue?vue&type=script&lang=js"
export * from "./TechnicalInformationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497e8422",
  null
  
)

export default component.exports